// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials-section {
  position: relative;
  scroll-margin-top: 4.5rem;
  background: var(--bg-surface-alt);
  border-bottom: 1px solid var(--border-subtle);
}

.testimonials-section__inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 4.5rem 1.25rem;
}

.testimonials-section__intro {
  text-align: center;
  max-width: 56ch;
  margin: 0 auto 3rem;
}

.testimonials-section__eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--interactive-hover);
  margin-bottom: 0.75rem;
}

.testimonials-section__subtitle {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
}

/* ---------- Grid ---------- */

.testimonials-grid {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 900px;
  margin: 0 auto;
  gap: 1.5rem;
  align-items: stretch;
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 1.75rem;
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition), box-shadow var(--transition);
}

.testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.testimonial-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.testimonial-card__quote-icon {
  color: var(--interactive);
  opacity: 0.6;
}

.testimonial-card__quote-icon svg {
  width: 2rem;
  height: 2rem;
}

.testimonial-card__source svg {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--radius-pill);
}

.testimonial-card__rating {
  display: flex;
  gap: 0.15rem;
  color: var(--interactive);
  margin-bottom: 0.9rem;
}

.testimonial-card__star {
  width: 1rem;
  height: 1rem;
}

.testimonial-card__quote {
  flex: 1 1;
  color: var(--text-secondary);
  font-size: 0.92rem;
  line-height: 1.65;
  margin-bottom: 0.5rem;
}

.testimonial-card__toggle {
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 1.25rem;
  color: var(--interactive-hover);
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: color var(--transition);
}

.testimonial-card__toggle:hover,
.testimonial-card__toggle:focus-visible {
  color: var(--interactive-active);
}

.testimonial-card__author {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
  padding-top: 0.9rem;
  border-top: 1px solid var(--border-subtle);
}

/* ---------- CTA ---------- */

.testimonials-section__cta {
  display: flex;
  justify-content: center;
  margin-top: 3.5rem;
}

/* ---------- Responsive ---------- */

@media (max-width: 620px) {
  .testimonials-section__inner {
    padding: 3rem 1rem;
  }

  .testimonials-section__intro {
    margin-bottom: 2.25rem;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .testimonial-card {
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/TestimonialsSection/TestimonialsSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qCAAqC;;AAErC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".testimonials-section {\n  position: relative;\n  scroll-margin-top: 4.5rem;\n  background: var(--bg-surface-alt);\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.testimonials-section__inner {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 4.5rem 1.25rem;\n}\n\n.testimonials-section__intro {\n  text-align: center;\n  max-width: 56ch;\n  margin: 0 auto 3rem;\n}\n\n.testimonials-section__eyebrow {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--interactive-hover);\n  margin-bottom: 0.75rem;\n}\n\n.testimonials-section__subtitle {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* ---------- Grid ---------- */\n\n.testimonials-grid {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  max-width: 900px;\n  margin: 0 auto;\n  gap: 1.5rem;\n  align-items: stretch;\n}\n\n.testimonial-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  padding: 1.75rem;\n  box-shadow: var(--shadow-sm);\n  transition: transform var(--transition), box-shadow var(--transition);\n}\n\n.testimonial-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.testimonial-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n\n.testimonial-card__quote-icon {\n  color: var(--interactive);\n  opacity: 0.6;\n}\n\n.testimonial-card__quote-icon svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.testimonial-card__source svg {\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: var(--radius-pill);\n}\n\n.testimonial-card__rating {\n  display: flex;\n  gap: 0.15rem;\n  color: var(--interactive);\n  margin-bottom: 0.9rem;\n}\n\n.testimonial-card__star {\n  width: 1rem;\n  height: 1rem;\n}\n\n.testimonial-card__quote {\n  flex: 1;\n  color: var(--text-secondary);\n  font-size: 0.92rem;\n  line-height: 1.65;\n  margin-bottom: 0.5rem;\n}\n\n.testimonial-card__toggle {\n  align-self: flex-start;\n  background: none;\n  border: none;\n  padding: 0;\n  margin-bottom: 1.25rem;\n  color: var(--interactive-hover);\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: color var(--transition);\n}\n\n.testimonial-card__toggle:hover,\n.testimonial-card__toggle:focus-visible {\n  color: var(--interactive-active);\n}\n\n.testimonial-card__author {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  padding-top: 0.9rem;\n  border-top: 1px solid var(--border-subtle);\n}\n\n/* ---------- CTA ---------- */\n\n.testimonials-section__cta {\n  display: flex;\n  justify-content: center;\n  margin-top: 3.5rem;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 620px) {\n  .testimonials-section__inner {\n    padding: 3rem 1rem;\n  }\n\n  .testimonials-section__intro {\n    margin-bottom: 2.25rem;\n  }\n\n  .testimonials-grid {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .testimonial-card {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
